import React from "react";

import { Button, Label } from "@components";
import { If } from "shared/components/control-statements";
import { SuccessIcon } from "shared/components/Icons";
import LazyInput from "shared/components/LazyInput";
import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { CustomerAPI } from "providers/CustomerAPI";
import { Phone } from "shared/utils/Phone";

export default class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      option: null,
      generatedPassword: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible === true) {
      this.reset();
    }
  }

  reset() {
    this.setState({
      option: null,
      loading: false,
      generatedPassword: null,
    });
  }

  async findOptions(term) {
    const customerResponse = await CustomerAPI.getCustomers({
      term,
      page: 0,
      limit: 100,
    });

    const customers = customerResponse.getData([]);

    this.setState({
      option: null,
    });

    return customers.map((customer) => {
      const phone = Phone.mask(customer.phone);
      return {
        id: customer.id,
        label: `${phone} - ${customer.email}`,
        name: customer.name,
      };
    });
  }

  async save() {
    const { option } = this.state;

    this.setState({
      loading: true,
    });

    const customerId = option.id;

    const resetResponse = await CustomerAPI.resetPassword(customerId);

    if (resetResponse.getErrors([]).length > 0) {
      this.setState({
        loading: false,
      });

      return alert({ text: resetResponse.getErrors()[0], buttonText: "Ok" });
    }

    const { password } = resetResponse.getData({});

    this.setState({
      generatedPassword: password,
      loading: false,
    });
  }

  copyToClipboard() {
    const { generatedPassword } = this.state;

    if (!generatedPassword) return;

    navigator.clipboard.writeText(generatedPassword).catch((err) => {
      console.error("Erro ao copiar: ", err);
    });
  }

  render() {
    const { loading, option, generatedPassword } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        showBackButton={true}
        showCloseButton={false}
        backButton={onClose}
        title={
          generatedPassword ? "Senha redefinida com sucesso" : "Redefinir senha"
        }
        subtitle={
          generatedPassword ? "Copie a senha e transfira para o cliente" : null
        }
      >
        <div className={styles.secretDrawerContainer}>
          <If cond={!generatedPassword}>
            <Label text="Insira o número, e-mail ou nome do cliente abaixo:" />
            <LazyInput
              placeholder="Buscar por..."
              minTextLength={1}
              design="search"
              fillText={false}
              onOption={(option) => {
                this.setState({ option: option });
              }}
              findOptions={(term) => this.findOptions(term)}
            />

            <If cond={option}>
              <div className="mt-20 mb-20">
                <div className={styles.customer}>
                  <p className={styles.name}>{option?.name}</p>
                  <p className={styles.label}>{option?.label}</p>
                </div>
              </div>
              <Button
                design="three"
                onClick={() => this.save()}
                loading={loading}
                disabled={loading}
              >
                Gerar nova senha
              </Button>
            </If>
          </If>

          <If cond={generatedPassword}>
            <div className={styles.success}>
              <div className={styles.successIcon}>
                <SuccessIcon color="#1f1f1f" size={14} />
              </div>
              <p className={styles.generatedPassword}>{generatedPassword}</p>
              <div
                className={styles.copy}
                onClick={this.copyToClipboard.bind(this)}
              >
                <i className="fal fa-copy" />
                <span>Copiar para área de transferência</span>
              </div>
            </div>

            <div className={styles.footer}>
              <Button design="primary" className="w-100" onClick={onClose}>
                Fechar
              </Button>
            </div>
          </If>
        </div>
      </Drawer>
    );
  }
}
